module.exports = __webpack_public_path__ + "media/images/countrysquared/aw-a04f46b910e8910ae6ba965fcfda7076.svg";